/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PF Appointments API
 * appointments-api v1. Generated from the route table; do not edit by hand (pnpm openapi).
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod'

export const publicOptionsCombosItemLocationIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const publicOptionsCombosItemProviderIdsItemRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const publicOptionsCombosItemVisitTypeIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const publicOptionsDefaultVisitTypeIdOneRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const publicOptionsLocationsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const publicOptionsPresetOneLocationIdOneRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const publicOptionsPresetOneProviderIdOneRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const publicOptionsPresetOneVisitTypeIdOneRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const publicOptionsProvidersItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const publicOptionsVisitTypesItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const publicOptionsWindowFirstDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$')
export const publicOptionsWindowLastDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$')

export const PublicOptions = zod.object({
  combos: zod.array(
    zod.object({
      locationId: zod.uuid().regex(publicOptionsCombosItemLocationIdRegExp),
      providerIds: zod.array(zod.uuid().regex(publicOptionsCombosItemProviderIdsItemRegExp)),
      visitTypeId: zod.uuid().regex(publicOptionsCombosItemVisitTypeIdRegExp),
    }),
  ),
  defaultVisitTypeId: zod.union([zod.uuid().regex(publicOptionsDefaultVisitTypeIdOneRegExp), zod.null()]),
  locations: zod.array(
    zod.object({
      address: zod.string(),
      id: zod.uuid().regex(publicOptionsLocationsItemIdRegExp),
      name: zod.string(),
    }),
  ),
  preset: zod.union([
    zod.object({
      locationId: zod.union([zod.uuid().regex(publicOptionsPresetOneLocationIdOneRegExp), zod.null()]),
      locked: zod.boolean(),
      providerId: zod.union([zod.uuid().regex(publicOptionsPresetOneProviderIdOneRegExp), zod.null()]),
      stale: zod.boolean(),
      visitTypeId: zod.union([zod.uuid().regex(publicOptionsPresetOneVisitTypeIdOneRegExp), zod.null()]),
    }),
    zod.null(),
  ]),
  providers: zod.array(
    zod.object({
      bio: zod.string(),
      color: zod.string(),
      credentials: zod.string(),
      id: zod.uuid().regex(publicOptionsProvidersItemIdRegExp),
      name: zod.string(),
      specialty: zod.string(),
    }),
  ),
  visitReasons: zod.array(zod.string()),
  visitTypes: zod.array(
    zod.object({
      id: zod.uuid().regex(publicOptionsVisitTypesItemIdRegExp),
      name: zod.string(),
      telehealth: zod.boolean(),
    }),
  ),
  window: zod.object({
    firstDate: zod.string().regex(publicOptionsWindowFirstDateRegExp),
    lastDate: zod.string().regex(publicOptionsWindowLastDateRegExp),
  }),
})

export type PublicOptions = zod.input<typeof PublicOptions>
export type PublicOptionsOutput = zod.output<typeof PublicOptions>
